import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import firebase from 'firebase/app';
// import 'firebase/auth';
// import 'firebase/firestore';
import 'firebase/database';
import 'firebase/app-check';
import firebaseConfig from './firebase_config';
import Form from './Form';
import Dashboard from './dashboard';
// import logo from './logo.svg';
// import './App.css';
import "bootstrap/dist/css/bootstrap.css";
import background from "./bg.jpg";

firebase.initializeApp(firebaseConfig);

if (firebaseConfig.useEmulator === true) {
  firebase.database().useEmulator("localhost", 9000);
} else {
  const appCheck = firebase.appCheck();
  appCheck.activate(
    '6LecsNIbAAAAANsNb8zz9CUJ7Ni5RFxCrPRNTI7p',
    true);
}


// function defualt() {
//   return (
//     <header className="App-header">
//       <img src={logo} className="App-logo" alt="logo" />
//       <p>
//         Edit <code>src/App.js</code> and save to reload.
//       </p>
//       <a
//         className="App-link"
//         href="https://reactjs.org"
//         target="_blank"
//         rel="noopener noreferrer"
//       >
//         Learn React
//       </a>
//     </header>
//   );
// }

function App() {
  return (
    <Router basename={'/data'}>
      <div className="App">
        <Switch>
          <Route path="/form/:id/:postId"
            // component={Form} loadFormSetting={loadFormSetting}
            render={props => (
              <Form {...props} firebase={firebase} />
            )}
          />
          <Route path="/form/:id"
            // component={Form} loadFormSetting={loadFormSetting}
            render={props => (
              <Form {...props} firebase={firebase} />
            )}
          />
          <Route path="/dashboard"
            render={props => (
              <Dashboard />
            )}
          />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
